import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

interface ScrollRevealProps {
  children: React.ReactNode;
  className?: string;
  direction?: "up" | "left" | "right" | "scale";
  delay?: number;
}

const ScrollReveal = ({ children, className = "", direction = "up", delay = 0 }: ScrollRevealProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 90%", "start 50%"],
  });

  const opacity = useTransform(scrollYProgress, [0, 1], [0, 1]);

  const variants = {
    up: { y: useTransform(scrollYProgress, [0, 1], [60, 0]) },
    left: { x: useTransform(scrollYProgress, [0, 1], [-80, 0]) },
    right: { x: useTransform(scrollYProgress, [0, 1], [80, 0]) },
    scale: { scale: useTransform(scrollYProgress, [0, 1], [0.85, 1]) },
  };

  return (
    <motion.div
      ref={ref}
      style={{
        opacity,
        ...variants[direction],
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
